export default "__VITE_ASSET__C1D79qez__"